/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import workstationFields from "../store/constants/workstationFields"
import { setBarPanelData, setCriticalJobsData } from "../store/slice/roomSlices/workstationRoomSlice";
import store from "../store/store";
import { updateCenterGraph } from "./updateCenterGraph";

export const updateWorkstationRoom = (path, data) => {
    const dispatch = store.dispatch;

    const keys = path.split("/:");
    const root = keys[0];
    const depth = keys.length - 1;
    const field = keys[depth];

    switch (root) {
        case workstationFields.CRITICAL_JOBS_DATA:
            dispatch(setCriticalJobsData({ field, data }))
            break;

        case workstationFields.BAR_PANEL_DATA:
            if (!isChartEmpty(data))
                dispatch(setBarPanelData(data))
            break;

        case workstationFields.CENTER_GRAPH:
            updateCenterGraph(dispatch, data)
            break;

        default:
            console.log("case: ", root, "not yet implemented");
            break;
    }
};

const isChartEmpty = (data) => {
    return data.values.every((charts) => {
        return charts.values.every((value) => value === 0)
    })
}